import { BASE_PATH } from "../utils/Contants";
import { state } from "../Main";
import { PROJECT_INDEX_SELECT } from "../templates/ProjectIndexPage";
import { tracking } from "../utils/Tracking";

export class ProjectIndexItem {
  public element: HTMLElement;
  public data: any;

  constructor(projectData, activeCategory) {
    this.data = projectData;

    //award tag
    let isAward = "";
    projectData.students.forEach(student => {
      if (student.awards) {
        isAward = "show-award";
      }
    });
    if (projectData.awards) {
      isAward = "show-award";
    }

    //title
    const div = document.createElement("div");
    let year = projectData.students[0] ? projectData.students[0].year : "";
    //year = year.length > 1 ? year[1] : '';

    let subtitle =
      projectData.programmeName !== ""
        ? projectData.programmeName
        : projectData.programme.title;

    if (projectData.unit.code && !projectData.groupValue) {
      subtitle += ", " + projectData.unit.code;
    }
    if (projectData.groupValue) {
      subtitle += ", " + projectData.groupValue;
    }
    if (
      year &&
      projectData.unit.code.indexOf("Year") < 0 &&
      projectData.hideYearInfo !== "1"
    ) {
      subtitle += ", Year " + year;
    }

    //image
    let imgUrl = projectData.heroImageUrl;

    //student category display
    let studentAndGroup = "";
    if (activeCategory == "students") {
      studentAndGroup = projectData.students[0].name;
      if (projectData.teamName) {
        studentAndGroup += ", " + projectData.teamName;
      }
      if (projectData.students[0].heroImageUrl) {
        //imgUrl = projectData.students[0].heroImageUrl;
      }
    }
    //awards category display
    else if (activeCategory == "awards") {
      if (projectData.students.length > 1) {
        studentAndGroup = projectData.teamName
          ? projectData.teamName
          : "Group Project";
      } else {
        studentAndGroup = projectData.students[0].name;
        if (projectData.students[0].heroImageUrl) {
          imgUrl = projectData.students[0].heroImageUrl;
        }
      }
    } else {
      if (projectData.students.length > 1) {
        studentAndGroup = projectData.teamName
          ? projectData.teamName
          : "Group Project";
      } else {
        studentAndGroup = projectData.students[0]
          ? projectData.students[0].name
          : "";
      }
    }

    const comingSoonMediaClass =
      projectData.comingSoon !== "1" ? "" : "media--coming-soon";
    const comingSoonHtml =
      projectData.comingSoon !== "1"
        ? ""
        : `
    <div class="coming-soon">
      <div class="inner">
        <span>Coming soon</span>
      </div>
    </div>
    `;

    const mediaInfoHtml = `
      <div class="media-wrapper" style="padding-bottom: ${(9 / 16) * 100}%">
        <div>
          <img class="lazyload ${comingSoonMediaClass}" data-src="${imgUrl +
      "?w=400&fm=jpg"}" alt="${projectData.title}">
        </div>
        <span class="award">AWARD</span>
        ${comingSoonHtml}
      </div>
      <div class="info-wrapper">
        <span class="title">${projectData.title}</span>
        <span class="student">${studentAndGroup}</span>
        <span class="subtitle">${subtitle}</span>
      </div>
    `;

    let innerWrapperHtml;
    if (projectData.comingSoon !== "1") {
      innerWrapperHtml = `
        <a class="no-ul" href="${BASE_PATH +
          projectData.unit.slug +
          "/" +
          projectData.slug}">
        ${mediaInfoHtml}
        </a>
		  `;
    } else {
      innerWrapperHtml = mediaInfoHtml;
    }

    div.innerHTML = `
      <div class="project-index-item ${isAward}">
      ${innerWrapperHtml}
      </div>
    `;

    this.element = div.firstElementChild as HTMLElement;

    if (this.element.querySelector("a")) {
      this.element.querySelector("a").addEventListener("click", e => {
        const target = e.target as HTMLAnchorElement;
        tracking.event("click", "project-index", target.href);
        state.setValue(PROJECT_INDEX_SELECT, true);
      });
    }
  }
}
